//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.MoveBuilder.js";
import "../CAM/CAM.TurnCircularFeedComp.js";
import "../CAM/CAM.TurnCornerControl.js";
import "../CAM/CAM.TurnCutterClearance.js";
import "../CAM/CAM.TurnDirection.js";
import "../CAM/CAM.FeedsTurnBuilder.js";
import "../CAM/CAM.TurnStock.js";
import "../CAM/CAM.Inheritable2dLength.js";
let d=[[[0,"ApplyEngageSettings",1,0],[0,"ApplyRetractSettings",1,0],[0,"AxialSafeClearance",1,0],[1,"CircularFeedCompBuilder",0,"CAM.TurnCircularFeedComp",0],[1,"CornerControlNormal",0,"CAM.TurnCornerControl",0],[1,"CornerControlShallow",0,"CAM.TurnCornerControl",0],[0,"CustomDriveCurve",0,"CAM.Boundary",0],[1,"CutterClearance",0,"CAM.TurnCutterClearance",0],[1,"Direction",0,"CAM.TurnDirection",0],[0,"DriveGeometryType",1,0],[0,"EndCheckBoundary",0,"CAM.Boundary",0],[1,"Feeds",0,"CAM.FeedsTurnBuilder",0],[1,"FinishStock",0,"CAM.TurnStock",0],[0,"NewDriveCurve",0,"CAM.Boundary",0],[0,"RadialSafeClearance",1,0],[0,"StartCheckBoundary",0,"CAM.Boundary",0],[0,"StartCheckConstantStock",1,0],[0,"StartCheckFaceStock",1,0],[0,"StartCheckRadialStock",1,0],[0,"StartPoint",1,"Point",0],[0,"StartPositionMethod",1,0],[0,"StartStopBeforeBoundaryOffset",1,0],[0,"StopCheckConstantStock",1,0],[0,"StopCheckFaceStock",1,0],[0,"StopCheckRadialStock",1,0],[0,"StopPoint",1,"Point",0],[0,"StopPositionMethod",1,0],[1,"Tolerances",0,"CAM.Inheritable2dLength",0]],[],[]];
SPLM.CAM.TeachmodeProfileMoveBuilder = class extends SPLM.CAM.MoveBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.TeachmodeProfileMoveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.TeachmodeProfileMoveBuilder.DriveGeometryTypes = Object.freeze({
    "PreviousCheck" : "PreviousCheck", "PreviousDrive" : "PreviousDrive", "NewDrive" : "NewDrive"});

SPLM.CAM.TeachmodeProfileMoveBuilder.StartStopPositionMethods = Object.freeze({
    "Drive" : "Drive", "Point" : "Point", "Check" : "Check", "ContourPosition" : "ContourPosition"});

export default SPLM;